import { useEffect, useRef } from "react";

// Regla general: toda pantalla que muestra estado del servidor lo vuelve a pedir
// cuando la ventana toma foco (o la pestaña se vuelve visible). Así, si alguien deja
// la pestaña abierta y cambia el dato desde otro lado, al volver ve lo real.
// Coalesce: al volver a una pestaña el navegador suele emitir focus Y visibilitychange
// casi juntos; agrupamos en una sola llamada para no duplicar pedidos.
export default function useRefetchOnFocus(fn, enabled = true) {
  const timer = useRef(null);
  useEffect(() => {
    if (!enabled || typeof fn !== "function") return;
    const trigger = () => {
      if (document.visibilityState === "hidden") return;
      if (timer.current) return;
      timer.current = setTimeout(() => { timer.current = null; fn(); }, 150);
    };
    window.addEventListener("focus", trigger);
    document.addEventListener("visibilitychange", trigger);
    return () => {
      window.removeEventListener("focus", trigger);
      document.removeEventListener("visibilitychange", trigger);
      if (timer.current) { clearTimeout(timer.current); timer.current = null; }
    };
  }, [fn, enabled]);
}
